import React from 'react';
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

const styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;

export const PageNotFoundSVG = (): React.JSX.Element => (
	<svg
		width="476.06"
		height="482.63"
		viewBox="0 0 476.06 482.63"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<defs>
			<linearGradient
				id="linear-gradient"
				x1="319.98"
				y1="322.55"
				x2="426.85"
				y2="215.68"
				gradientTransform="translate(-227.29)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#b3f5ff" stopOpacity="0" />
				<stop offset=".06" stopColor="#b3f5ff" stopOpacity=".1" />
				<stop offset=".27" stopColor="#b3f5ff" stopOpacity=".42" />
				<stop offset=".45" stopColor="#b3f5ff" stopOpacity=".67" />
				<stop offset=".6" stopColor="#b3f5ff" stopOpacity=".85" />
				<stop offset=".72" stopColor="#b3f5ff" stopOpacity=".96" />
				<stop offset=".79" stopColor="#b3f5ff" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-2"
				x1="7261.66"
				y1="168.49"
				x2="7391.94"
				y2="38.21"
				gradientTransform="matrix(-1 0 0 1 7632.29 0)"
				xlinkHref="#linear-gradient"
			/>
			<linearGradient
				id="linear-gradient-3"
				x1="146.17"
				y1="164.89"
				x2="239.99"
				y2="71.07"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#00c7e5" />
				<stop offset="1" stopColor="#b3f5ff" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-4"
				x1="782.51"
				y1="-1187.31"
				x2="790.62"
				y2="-1204.87"
				gradientTransform="rotate(-24.78 3495.39 868.508)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".25" stopColor="#00b8d9" />
				<stop offset="1" stopColor="#79e2f2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-5"
				x1="5.81"
				y1="472.52"
				x2="5.81"
				y2="284.67"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".43" stopColor="#b3f5ff" />
				<stop offset="1" stopColor="#79e2f2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-6"
				x1="8.47"
				y1="472.52"
				x2="8.47"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-7"
				x1="69.15"
				y1="472.52"
				x2="69.15"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-8"
				x1="63.61"
				y1="472.52"
				x2="63.61"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-9"
				x1="67.33"
				y1="472.52"
				x2="67.33"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-10"
				x1="68.21"
				y1="472.52"
				x2="68.21"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-11"
				x1="68.78"
				y1="472.52"
				x2="68.78"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-12"
				x1="69.36"
				y1="472.52"
				x2="69.36"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-13"
				x1="52.51"
				y1="472.52"
				x2="52.51"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-14"
				x1="56.67"
				y1="472.52"
				x2="56.67"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-15"
				x1="54.47"
				y1="472.52"
				x2="54.47"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-16"
				x1="60.3"
				y1="472.52"
				x2="60.3"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-17"
				x1="62.16"
				y1="472.52"
				x2="62.16"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-18"
				x1="58.5"
				y1="472.52"
				x2="58.5"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-19"
				x1="66.35"
				y1="472.52"
				x2="66.35"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-20"
				x1="3.23"
				y1="472.52"
				x2="3.23"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-21"
				x1="160.2"
				y1="472.52"
				x2="160.2"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-22"
				x1="71.2"
				y1="472.52"
				x2="71.2"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-23"
				x1="271.02"
				y1="472.52"
				x2="271.02"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-24"
				x1="4.82"
				y1="472.52"
				x2="4.82"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-25"
				x1="69.36"
				y1="472.52"
				x2="69.36"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-26"
				x1="195.3"
				y1="472.52"
				x2="195.3"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-27"
				x1="3.53"
				y1="472.52"
				x2="3.53"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-28"
				x1="3.37"
				y1="472.52"
				x2="3.37"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-29"
				x1="4.07"
				y1="472.52"
				x2="4.07"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-30"
				x1="273.13"
				y1="472.52"
				x2="273.13"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-31"
				x1="273.13"
				y1="462.4"
				x2="273.13"
				y2="337.02"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".31" stopColor="#b3f5ff" />
				<stop offset=".79" stopColor="#79e2f2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-32"
				x1="220.7"
				y1="472.52"
				x2="220.7"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-33"
				x1="220.7"
				y1="462.4"
				x2="220.7"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-34"
				x1="185.46"
				y1="472.52"
				x2="185.46"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-35"
				x1="185.46"
				y1="402.18"
				x2="185.46"
				y2="337.02"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#b3f5ff" />
				<stop offset=".05" stopColor="#abf2fd" />
				<stop offset=".22" stopColor="#95ebf8" />
				<stop offset=".4" stopColor="#85e6f5" />
				<stop offset=".61" stopColor="#7ce3f3" />
				<stop offset=".91" stopColor="#79e2f2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-36"
				x1="148.26"
				y1="472.52"
				x2="148.26"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-37"
				x1="148.26"
				y1="402.18"
				x2="148.26"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-38"
				x1="186.02"
				y1="472.52"
				x2="186.02"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-39"
				x1="186.02"
				y1="462.4"
				x2="186.02"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-40"
				x1="186.02"
				y1="402.18"
				x2="186.02"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-41"
				x1="214.14"
				y1="472.52"
				x2="214.14"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-42"
				x1="214.14"
				y1="462.4"
				x2="214.14"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-43"
				x1="214.14"
				y1="402.18"
				x2="214.14"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-44"
				x1="185.54"
				y1="402.18"
				x2="185.54"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-45"
				x1="338.36"
				y1="472.52"
				x2="338.36"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-46"
				x1="338.36"
				y1="402.18"
				x2="338.36"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-47"
				x1="283.93"
				y1="472.52"
				x2="283.93"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-48"
				x1="283.93"
				y1="462.4"
				x2="283.93"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-49"
				x1="283.93"
				y1="402.18"
				x2="283.93"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-50"
				x1="403.38"
				y1="472.52"
				x2="403.38"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-51"
				x1="396.98"
				y1="411.33"
				x2="409.97"
				y2="305.52"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#b3f5ff" />
				<stop offset="0" stopColor="#b3f5ff" stopOpacity=".96" />
				<stop offset=".02" stopColor="#b3f5ff" stopOpacity=".78" />
				<stop offset=".05" stopColor="#b3f5ff" stopOpacity=".61" />
				<stop offset=".07" stopColor="#b3f5ff" stopOpacity=".47" />
				<stop offset=".1" stopColor="#b3f5ff" stopOpacity=".34" />
				<stop offset=".13" stopColor="#b3f5ff" stopOpacity=".23" />
				<stop offset=".17" stopColor="#b3f5ff" stopOpacity=".15" />
				<stop offset=".21" stopColor="#b3f5ff" stopOpacity=".08" />
				<stop offset=".26" stopColor="#b3f5ff" stopOpacity=".03" />
				<stop offset=".33" stopColor="#b3f5ff" stopOpacity=".01" />
				<stop offset=".52" stopColor="#b3f5ff" stopOpacity="0" />
				<stop offset=".67" stopColor="#b3f5ff" stopOpacity=".01" />
				<stop offset=".74" stopColor="#b3f5ff" stopOpacity=".04" />
				<stop offset=".79" stopColor="#b3f5ff" stopOpacity=".09" />
				<stop offset=".83" stopColor="#b3f5ff" stopOpacity=".16" />
				<stop offset=".86" stopColor="#b3f5ff" stopOpacity=".25" />
				<stop offset=".9" stopColor="#b3f5ff" stopOpacity=".36" />
				<stop offset=".93" stopColor="#b3f5ff" stopOpacity=".49" />
				<stop offset=".95" stopColor="#b3f5ff" stopOpacity=".65" />
				<stop offset=".98" stopColor="#b3f5ff" stopOpacity=".82" />
				<stop offset="1" stopColor="#b3f5ff" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-52"
				x1="2.42"
				y1="362.88"
				x2="15.41"
				y2="257.07"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-53"
				x1="3.3"
				y1="362.99"
				x2="16.29"
				y2="257.18"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-54"
				x1="4.38"
				y1="363.12"
				x2="17.37"
				y2="257.31"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-55"
				x1="1.14"
				y1="362.72"
				x2="14.13"
				y2="256.91"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-56"
				x1="5.69"
				y1="363.28"
				x2="18.68"
				y2="257.47"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-57"
				x1="1.05"
				y1="362.71"
				x2="14.04"
				y2="256.9"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-58"
				x1="10.57"
				y1="363.88"
				x2="11.95"
				y2="352.66"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-59"
				x1="1.74"
				y1="362.79"
				x2="14.73"
				y2="256.99"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-60"
				x1="171.14"
				y1="472.52"
				x2="171.14"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-61"
				x1="165.11"
				y1="382.85"
				x2="178.1"
				y2="277.05"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-62"
				x1="251.72"
				y1="472.52"
				x2="251.72"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-63"
				x1="251.72"
				y1="462.4"
				x2="251.72"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-64"
				x1="249.31"
				y1="393.2"
				x2="262.3"
				y2="287.39"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-65"
				x1="237.87"
				y1="472.52"
				x2="237.87"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-66"
				x1="237.87"
				y1="462.4"
				x2="237.87"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-67"
				x1="235.86"
				y1="391.55"
				x2="248.85"
				y2="285.74"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-68"
				x1="153.84"
				y1="472.52"
				x2="153.84"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-69"
				x1="153.84"
				y1="402.18"
				x2="153.84"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-70"
				x1="152.5"
				y1="381.31"
				x2="165.5"
				y2="275.5"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-71"
				x1="172.27"
				y1="472.52"
				x2="172.27"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-72"
				x1="172.27"
				y1="462.4"
				x2="172.27"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-73"
				x1="172.27"
				y1="402.18"
				x2="172.27"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-74"
				x1="168.95"
				y1="383.33"
				x2="181.94"
				y2="277.52"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-75"
				x1="221.37"
				y1="472.52"
				x2="221.37"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-76"
				x1="221.37"
				y1="462.4"
				x2="221.37"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-77"
				x1="221.37"
				y1="402.18"
				x2="221.37"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-78"
				x1="218.94"
				y1="389.47"
				x2="231.93"
				y2="283.66"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-79"
				x1="187.52"
				y1="472.52"
				x2="187.52"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-80"
				x1="187.52"
				y1="462.4"
				x2="187.52"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-81"
				x1="187.52"
				y1="402.18"
				x2="187.52"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-82"
				x1="184.77"
				y1="385.27"
				x2="197.76"
				y2="279.47"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-83"
				x1="180.43"
				y1="402.18"
				x2="180.43"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-84"
				x1="178.58"
				y1="384.51"
				x2="191.57"
				y2="278.7"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-85"
				x1="193.4"
				y1="402.18"
				x2="193.4"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-86"
				x1="191.37"
				y1="386.08"
				x2="204.37"
				y2="280.28"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-87"
				x1="240.98"
				y1="392.17"
				x2="253.97"
				y2="286.37"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-88"
				x1="333.44"
				y1="472.52"
				x2="333.44"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-89"
				x1="333.44"
				y1="402.18"
				x2="333.44"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-90"
				x1="329.79"
				y1="403.08"
				x2="342.78"
				y2="297.27"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-91"
				x1="283.96"
				y1="472.52"
				x2="283.96"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-92"
				x1="283.96"
				y1="462.4"
				x2="283.96"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-93"
				x1="283.96"
				y1="402.18"
				x2="283.96"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-94"
				x1="279.87"
				y1="396.95"
				x2="292.86"
				y2="291.14"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-95"
				x1="204.11"
				y1="472.52"
				x2="204.11"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-96"
				x1="184.3"
				y1="387.71"
				x2="228.81"
				y2="265.4"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-97"
				x1="197.55"
				y1="386.84"
				x2="210.54"
				y2="281.03"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-98"
				x1="375.18"
				y1="472.52"
				x2="375.18"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-99"
				x1="339.82"
				y1="444.31"
				x2="384.34"
				y2="322.01"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-100"
				x1="367.74"
				y1="407.74"
				x2="380.74"
				y2="301.93"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-101"
				x1="154.96"
				y1="472.52"
				x2="154.96"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-102"
				x1="154.96"
				y1="402.18"
				x2="154.96"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-103"
				x1="148.01"
				y1="374.5"
				x2="192.52"
				y2="252.19"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-104"
				x1="151.79"
				y1="381.22"
				x2="164.78"
				y2="275.42"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-105"
				x1="202.83"
				y1="472.52"
				x2="202.83"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-106"
				x1="202.83"
				y1="462.4"
				x2="202.83"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-107"
				x1="202.83"
				y1="402.18"
				x2="202.83"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-108"
				x1="190.53"
				y1="389.97"
				x2="235.04"
				y2="267.67"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-109"
				x1="199.1"
				y1="387.03"
				x2="212.09"
				y2="281.22"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-110"
				x1="170.79"
				y1="472.52"
				x2="170.79"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-111"
				x1="170.79"
				y1="462.4"
				x2="170.79"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-112"
				x1="170.79"
				y1="402.18"
				x2="170.79"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-113"
				x1="161.27"
				y1="379.33"
				x2="205.79"
				y2="257.02"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-114"
				x1="166.95"
				y1="383.08"
				x2="179.94"
				y2="277.28"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-115"
				x1="188.51"
				y1="472.52"
				x2="188.51"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-116"
				x1="188.51"
				y1="462.4"
				x2="188.51"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-117"
				x1="188.51"
				y1="402.18"
				x2="188.51"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-118"
				x1="177.1"
				y1="385.09"
				x2="221.61"
				y2="262.78"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-119"
				x1="184.49"
				y1="385.24"
				x2="197.49"
				y2="279.43"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-120"
				x1="181.55"
				y1="402.18"
				x2="181.55"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-121"
				x1="171.4"
				y1="383.01"
				x2="215.92"
				y2="260.71"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-122"
				x1="178.12"
				y1="384.46"
				x2="191.11"
				y2="278.65"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-123"
				x1="195.05"
				y1="402.18"
				x2="195.05"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-124"
				x1="183.47"
				y1="387.41"
				x2="227.99"
				y2="265.1"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-125"
				x1="191.39"
				y1="386.09"
				x2="204.38"
				y2="280.28"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-126"
				x1="227.14"
				y1="403.3"
				x2="271.66"
				y2="281"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-127"
				x1="240.77"
				y1="392.15"
				x2="253.76"
				y2="286.34"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-128"
				x1="334.77"
				y1="472.52"
				x2="334.77"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-129"
				x1="334.77"
				y1="402.18"
				x2="334.77"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-130"
				x1="306.53"
				y1="432.19"
				x2="351.04"
				y2="309.89"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-131"
				x1="328.83"
				y1="402.96"
				x2="341.82"
				y2="297.15"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-132"
				x1="305.41"
				y1="472.52"
				x2="305.41"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-133"
				x1="305.41"
				y1="462.4"
				x2="305.41"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-134"
				x1="305.41"
				y1="402.18"
				x2="305.41"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-135"
				x1="280.29"
				y1="422.65"
				x2="324.81"
				y2="300.34"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-136"
				x1="299.79"
				y1="399.4"
				x2="312.78"
				y2="293.59"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-137"
				x1="237.39"
				y1="472.52"
				x2="237.39"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-138"
				x1="94.24"
				y1="336.36"
				x2="382.66"
				y2="336.36"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-139"
				x1="215.63"
				y1="399.11"
				x2="260.14"
				y2="276.81"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-140"
				x1="231.06"
				y1="390.96"
				x2="244.05"
				y2="285.15"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-141"
				x1="154.66"
				y1="472.52"
				x2="154.66"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-142"
				x1="154.66"
				y1="402.18"
				x2="154.66"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-143"
				x1="94.24"
				y1="347.55"
				x2="382.66"
				y2="347.55"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-144"
				x1="146.2"
				y1="373.84"
				x2="190.71"
				y2="251.53"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-145"
				x1="150.91"
				y1="381.12"
				x2="163.9"
				y2="275.31"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-146"
				x1="168.62"
				y1="472.52"
				x2="168.62"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-147"
				x1="168.62"
				y1="462.4"
				x2="168.62"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-148"
				x1="168.62"
				y1="402.18"
				x2="168.62"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-149"
				x1="94.24"
				y1="348.31"
				x2="382.66"
				y2="348.31"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-150"
				x1="157.53"
				y1="377.96"
				x2="202.04"
				y2="255.66"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-151"
				x1="164.09"
				y1="382.73"
				x2="177.09"
				y2="276.93"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-152"
				x1="188.58"
				y1="472.52"
				x2="188.58"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-153"
				x1="188.58"
				y1="462.4"
				x2="188.58"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-154"
				x1="188.58"
				y1="402.18"
				x2="188.58"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-155"
				x1="94.24"
				y1="350.99"
				x2="382.66"
				y2="350.99"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-156"
				x1="176.21"
				y1="384.76"
				x2="220.72"
				y2="262.46"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-157"
				x1="184.32"
				y1="385.22"
				x2="197.31"
				y2="279.41"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-158"
				x1="181.71"
				y1="402.18"
				x2="181.71"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-159"
				x1="94.24"
				y1="349.53"
				x2="382.66"
				y2="349.53"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-160"
				x1="170.01"
				y1="382.51"
				x2="214.52"
				y2="260.2"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-161"
				x1="177.73"
				y1="384.41"
				x2="190.72"
				y2="278.6"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-162"
				x1="193.08"
				y1="402.18"
				x2="193.08"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-163"
				x1="94.24"
				y1="352.21"
				x2="382.66"
				y2="352.21"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-164"
				x1="180.71"
				y1="386.4"
				x2="225.23"
				y2="264.1"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-165"
				x1="189.02"
				y1="385.79"
				x2="202.01"
				y2="279.99"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-166"
				x1="94.24"
				y1="349.07"
				x2="382.66"
				y2="349.07"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-167"
				x1="225.04"
				y1="402.53"
				x2="269.55"
				y2="280.23"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-168"
				x1="240.19"
				y1="392.08"
				x2="253.18"
				y2="286.27"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-169"
				x1="335.09"
				y1="472.52"
				x2="335.09"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-170"
				x1="335.09"
				y1="402.18"
				x2="335.09"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-171"
				x1="94.24"
				y1="346.43"
				x2="382.66"
				y2="346.43"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-172"
				x1="305.17"
				y1="431.7"
				x2="349.68"
				y2="309.4"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-173"
				x1="328.53"
				y1="402.92"
				x2="341.52"
				y2="297.12"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-174"
				x1="314.18"
				y1="472.52"
				x2="314.18"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-175"
				x1="314.18"
				y1="462.4"
				x2="314.18"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-176"
				x1="314.18"
				y1="402.18"
				x2="314.18"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-177"
				x1="94.24"
				y1="347.82"
				x2="382.66"
				y2="347.82"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-178"
				x1="286.17"
				y1="424.78"
				x2="330.68"
				y2="302.48"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-179"
				x1="307.73"
				y1="400.37"
				x2="320.72"
				y2="294.56"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-180"
				x1="238.45"
				y1="472.52"
				x2="238.45"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-181"
				x1="94.24"
				y1="336.66"
				x2="382.66"
				y2="336.66"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-182"
				x1="120.57"
				y1="336.66"
				x2="356.32"
				y2="336.66"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-183"
				x1="216.19"
				y1="399.31"
				x2="260.7"
				y2="277.01"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-184"
				x1="231.95"
				y1="391.07"
				x2="244.94"
				y2="285.26"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-185"
				x1="154.01"
				y1="472.52"
				x2="154.01"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-186"
				x1="154.01"
				y1="402.18"
				x2="154.01"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-187"
				x1="94.24"
				y1="340.77"
				x2="382.66"
				y2="340.77"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-188"
				x1="120.57"
				y1="340.77"
				x2="356.32"
				y2="340.77"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-189"
				x1="143.55"
				y1="372.88"
				x2="188.07"
				y2="250.57"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-190"
				x1="149.49"
				y1="380.94"
				x2="162.48"
				y2="275.13"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-191"
				x1="164.37"
				y1="472.52"
				x2="164.37"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-192"
				x1="164.37"
				y1="462.4"
				x2="164.37"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-193"
				x1="164.37"
				y1="402.18"
				x2="164.37"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-194"
				x1="94.24"
				y1="341.24"
				x2="382.66"
				y2="341.24"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-195"
				x1="120.57"
				y1="341.24"
				x2="356.32"
				y2="341.24"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-196"
				x1="151.77"
				y1="375.87"
				x2="196.28"
				y2="253.56"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-197"
				x1="159.34"
				y1="382.15"
				x2="172.34"
				y2="276.34"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-198"
				x1="94.24"
				y1="341.91"
				x2="382.66"
				y2="341.91"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-199"
				x1="120.57"
				y1="341.91"
				x2="356.32"
				y2="341.91"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-200"
				x1="221.5"
				y1="401.25"
				x2="266.01"
				y2="278.94"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-201"
				x1="238.15"
				y1="391.83"
				x2="251.14"
				y2="286.02"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-202"
				x1="335.78"
				y1="472.52"
				x2="335.78"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-203"
				x1="335.78"
				y1="402.18"
				x2="335.78"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-204"
				x1="94.24"
				y1="340.23"
				x2="382.66"
				y2="340.23"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-205"
				x1="120.57"
				y1="340.23"
				x2="356.32"
				y2="340.23"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-206"
				x1="303.69"
				y1="431.16"
				x2="348.2"
				y2="308.86"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-207"
				x1="328.42"
				y1="402.91"
				x2="341.41"
				y2="297.1"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-208"
				x1="326.47"
				y1="472.52"
				x2="326.47"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-209"
				x1="326.47"
				y1="462.4"
				x2="326.47"
				y2="337.02"
				xlinkHref="#linear-gradient-31"
			/>
			<linearGradient
				id="linear-gradient-210"
				x1="326.47"
				y1="402.18"
				x2="326.47"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-211"
				x1="94.24"
				y1="340.83"
				x2="382.66"
				y2="340.83"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-212"
				x1="120.57"
				y1="340.83"
				x2="356.32"
				y2="340.83"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-213"
				x1="294.77"
				y1="427.92"
				x2="339.28"
				y2="305.61"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-214"
				x1="318.99"
				y1="401.75"
				x2="331.98"
				y2="295.94"
				xlinkHref="#linear-gradient-51"
			/>
			<linearGradient
				id="linear-gradient-215"
				x1="105.04"
				y1="472.52"
				x2="105.04"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-216"
				x1="134.74"
				y1="472.52"
				x2="134.74"
				y2="284.67"
				xlinkHref="#linear-gradient-5"
			/>
			<linearGradient
				id="linear-gradient-217"
				x1="134.74"
				y1="402.18"
				x2="134.74"
				y2="337.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-218"
				x1="115.09"
				y1="282.96"
				x2="376"
				y2="282.96"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#b3bac5" />
				<stop offset=".85" stopColor="#ebecf0" />
				<stop offset=".95" stopColor="#edeef1" />
				<stop offset=".98" stopColor="#f4f5f7" />
				<stop offset="1" stopColor="#fafbfc" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-219"
				x1="163.83"
				y1="347.6"
				x2="279.38"
				y2="232.05"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#c1c7d0" />
				<stop offset=".14" stopColor="#c9ced6" />
				<stop offset=".68" stopColor="#e2e4e9" />
				<stop offset="1" stopColor="#ebecf0" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-220"
				x1="291.34"
				y1="337.73"
				x2="291.34"
				y2="198.21"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".21" stopColor="#ebecf0" />
				<stop offset="1" stopColor="#fafbfc" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-221"
				x1="219.34"
				y1="215.53"
				x2="331.33"
				y2="215.53"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#091e42" />
				<stop offset=".18" stopColor="#091e42" stopOpacity=".85" />
				<stop offset=".5" stopColor="#091e42" stopOpacity=".45" />
				<stop offset=".66" stopColor="#091e42" stopOpacity=".2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-222"
				x1="4697.25"
				y1="308.96"
				x2="4793.78"
				y2="308.96"
				gradientTransform="matrix(-1 0 0 1 4935.69 0)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#091e42" stopOpacity="0" />
				<stop offset=".88" stopColor="#091e42" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-223"
				x1="-10103.77"
				y1="-1179.29"
				x2="-10103.77"
				y2="-1247.52"
				gradientTransform="matrix(.99 -.11 .11 .99 10362.66 390.81)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".37" stopColor="#00a3bf" />
				<stop offset=".88" stopColor="#00c7e5" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-224"
				x1="197.02"
				y1="184.01"
				x2="293.47"
				y2="87.57"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#091e42" />
				<stop offset=".13" stopColor="#091e42" stopOpacity=".85" />
				<stop offset=".36" stopColor="#091e42" stopOpacity=".45" />
				<stop offset=".48" stopColor="#091e42" stopOpacity=".2" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-225"
				x1="294.7"
				y1="238.16"
				x2="334.79"
				y2="238.16"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#0065ff" />
				<stop offset=".12" stopColor="#0d6eff" />
				<stop offset=".49" stopColor="#2f86ff" />
				<stop offset=".8" stopColor="#4495ff" />
				<stop offset="1" stopColor="#4c9aff" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-226"
				x1="245.55"
				y1="299.49"
				x2="376"
				y2="299.49"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#ebecf0" />
				<stop offset=".47" stopColor="#f5f6f8" />
				<stop offset="1" stopColor="#fafbfc" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-227"
				x1="153.96"
				y1="321.19"
				x2="337.13"
				y2="321.19"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#ebecf0" />
				<stop offset="1" stopColor="#dfe1e5" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-228"
				x1="115.09"
				y1="299.49"
				x2="245.55"
				y2="299.49"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#ebecf0" />
				<stop offset=".66" stopColor="#edeef1" />
				<stop offset=".9" stopColor="#f4f5f7" />
				<stop offset="1" stopColor="#fafbfc" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-229"
				x1="251.12"
				y1="196.75"
				x2="347.56"
				y2="100.3"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#ff991f" />
				<stop offset=".08" stopColor="#ffa219" />
				<stop offset=".33" stopColor="#ffbb07" />
				<stop offset=".48" stopColor="#ffc400" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-230"
				x1="-2946.9"
				y1="-501.86"
				x2="-2929.95"
				y2="-501.86"
				gradientTransform="matrix(-.75 .66 .66 .75 -1698.92 2528.01)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".54" stopColor="#00b8d9" />
				<stop offset=".66" stopColor="#00bddd" />
				<stop offset="1" stopColor="#00c7e5" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-231"
				x1="913.18"
				y1="236.51"
				x2="936.34"
				y2="213.36"
				gradientTransform="matrix(-1 0 0 1 1111.25 0)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#00a3bf" />
				<stop offset=".62" stopColor="#00c7e5" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-232"
				x1="2869.84"
				y1="1497.87"
				x2="2882.64"
				y2="1491.62"
				gradientTransform="matrix(-.9 -.43 -.43 .9 3435.48 110.98)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#00a3bf" />
				<stop offset=".26" stopColor="#00a8c5" />
				<stop offset=".6" stopColor="#00b8d5" />
				<stop offset=".84" stopColor="#00c7e5" />
			</linearGradient>
			<linearGradient
				id="New_Gradient_Swatch_13"
				x1="-6136.21"
				y1="5146.38"
				x2="-6130.92"
				y2="5141.09"
				gradientTransform="matrix(1 0 0 1.52 6291.96 -7637.21)"
				xlinkHref="#linear-gradient-3"
			/>
			<linearGradient
				id="New_Gradient_Swatch_13-2"
				x1="-6135.75"
				y1="5139.64"
				x2="-6131.37"
				y2="5135.26"
				gradientTransform="matrix(1 0 0 1.52 6301.53 -7627.42)"
				xlinkHref="#linear-gradient-3"
			/>
			<linearGradient
				id="New_Gradient_Swatch_13-3"
				x1="-6135.24"
				y1="5133.66"
				x2="-6131.89"
				y2="5130.31"
				gradientTransform="matrix(1 0 0 1.52 6309.67 -7619.1)"
				xlinkHref="#linear-gradient-3"
			/>
			<linearGradient
				id="linear-gradient-233"
				x1="177.32"
				y1="462.13"
				x2="177.32"
				y2="382.62"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".31" stopColor="#79e2f2" stopOpacity=".3" />
				<stop offset=".79" stopColor="#79e2f2" stopOpacity=".6" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-234"
				x1="303.59"
				y1="388.02"
				x2="303.59"
				y2="380.02"
				xlinkHref="#linear-gradient-35"
			/>
			<linearGradient
				id="linear-gradient-235"
				x1="310.94"
				y1="133.6"
				x2="337.06"
				y2="186.14"
				gradientTransform="matrix(1 0 0 -1 0 582.59)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".31" stopColor="#79e2f2" stopOpacity=".2" />
				<stop offset=".79" stopColor="#79e2f2" stopOpacity=".6" />
			</linearGradient>
			<radialGradient
				id="radial-gradient"
				cx="56.34"
				cy="388.26"
				r="81.68"
				gradientTransform="matrix(1 0 0 .19 0 315.55)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".11" stopColor="#e6fcff" />
				<stop offset=".31" stopColor="#e6fcff" stopOpacity=".73" />
				<stop offset=".56" stopColor="#e6fcff" stopOpacity=".42" />
				<stop offset=".77" stopColor="#e6fcff" stopOpacity=".19" />
				<stop offset=".92" stopColor="#e6fcff" stopOpacity=".05" />
				<stop offset="1" stopColor="#e6fcff" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="radial-gradient-2"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-3"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-4"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-5"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-6"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-7"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-8"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-9"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-10"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-12"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-13"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			<radialGradient
				id="radial-gradient-15"
				cx="56.34"
				cy="388.26"
				r="81.68"
				xlinkHref="#radial-gradient"
			/>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766 */}
			<style>{styles}</style>
		</defs>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */}
		<g style={{ isolation: 'isolate' }}>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_1-2" data-name="Layer 1">
					<path
						d="M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z"
						fill="url(#linear-gradient)"
					/>
					<path
						d="M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z"
						fill="url(#linear-gradient-2)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-4"
						d="M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
					/>
					<path
						d="M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
						fill="url(#linear-gradient-3)"
					/>
					<path
						d="M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z"
						fill="#e6fcff"
					/>
					<path
						d="M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z"
						fill="url(#linear-gradient-4)"
					/>
					<path
						d="M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z"
						fill="#0052cc"
					/>
					<path
						d="M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z"
						fill="#ffab00"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-4"
						d="M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
					/>
					<path
						d="M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
						opacity=".4"
						fill="#79e2f2"
					/>
					<path d="M6.25 358.05z" fill="url(#linear-gradient-5)" />
					<path
						d="M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z"
						fill="url(#linear-gradient-6)"
					/>
					<path
						d="M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z"
						fill="url(#linear-gradient-7)"
					/>
					<path d="M63.81 392.36l-.39-.3z" fill="url(#linear-gradient-8)" />
					<path d="M67.44 397l-.22-.43z" fill="url(#linear-gradient-9)" />
					<path d="M68.24 399l-.06-.19z" fill="url(#linear-gradient-10)" />
					<path
						d="M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z"
						fill="url(#linear-gradient-11)"
					/>
					<path d="M69.36 405.62z" fill="url(#linear-gradient-12)" />
					<path d="M52.78 387.47l-.54-.15z" fill="url(#linear-gradient-13)" />
					<path d="M56.85 388.76l-.36-.12z" fill="url(#linear-gradient-14)" />
					<path d="M54.69 388l-.45-.13z" fill="url(#linear-gradient-15)" />
					<path d="M60.44 390.25l-.28-.13z" fill="url(#linear-gradient-16)" />
					<path d="M62.35 391.32l-.38-.23z" fill="url(#linear-gradient-17)" />
					<path d="M58.76 389.5l-.51-.21z" fill="url(#linear-gradient-18)" />
					<path d="M66.5 395.35l-.3-.44z" fill="url(#linear-gradient-19)" />
					<path
						d="M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z"
						fill="url(#linear-gradient-20)"
					/>
					<path
						d="M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z"
						fill="url(#linear-gradient-21)"
					/>
					<path
						d="M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z"
						fill="url(#linear-gradient-22)"
					/>
					<path
						d="M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z"
						fill="url(#linear-gradient-23)"
					/>
					<path d="M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z" fill="url(#linear-gradient-24)" />
					<path d="M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z" fill="url(#linear-gradient-25)" />
					<path
						d="M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z"
						fill="url(#linear-gradient-26)"
					/>
					<path d="M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z" fill="url(#linear-gradient-27)" />
					<path
						d="M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z"
						fill="url(#linear-gradient-28)"
					/>
					<path
						d="M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z"
						fill="url(#linear-gradient-29)"
					/>
					<path
						d="M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z"
						fill="url(#linear-gradient-30)"
					/>
					<path
						d="M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z"
						fill="url(#linear-gradient-31)"
					/>
					<path
						d="M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z"
						fill="url(#linear-gradient-32)"
					/>
					<path
						d="M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z"
						fill="url(#linear-gradient-33)"
					/>
					<path
						d="M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z"
						fill="url(#linear-gradient-34)"
					/>
					<path
						d="M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z"
						fill="url(#linear-gradient-35)"
					/>
					<path
						d="M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z"
						fill="url(#linear-gradient-36)"
					/>
					<path
						d="M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z"
						fill="url(#linear-gradient-37)"
					/>
					<path
						d="M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z"
						fill="url(#linear-gradient-38)"
					/>
					<path
						d="M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z"
						fill="url(#linear-gradient-39)"
					/>
					<path
						d="M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z"
						fill="url(#linear-gradient-40)"
					/>
					<path
						d="M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z"
						fill="url(#linear-gradient-41)"
					/>
					<path
						d="M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z"
						fill="url(#linear-gradient-42)"
					/>
					<path
						d="M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z"
						fill="url(#linear-gradient-43)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
					/>
					<path
						d="M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
						fill="url(#linear-gradient-44)"
					/>
					<path
						d="M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z"
						fill="url(#linear-gradient-45)"
					/>
					<path
						d="M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z"
						fill="url(#linear-gradient-46)"
					/>
					<path
						d="M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z"
						fill="url(#linear-gradient-47)"
					/>
					<path
						d="M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z"
						fill="url(#linear-gradient-48)"
					/>
					<path
						d="M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z"
						fill="url(#linear-gradient-49)"
					/>
					<path
						d="M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z"
						fill="url(#linear-gradient-50)"
					/>
					<path
						d="M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z"
						fill="url(#linear-gradient-51)"
						opacity=".9"
					/>
					<path
						d="M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z"
						fill="url(#linear-gradient-52)"
						opacity=".9"
					/>
					<path d="M4.52 354.37z" fill="url(#linear-gradient-53)" opacity=".9" />
					<path d="M5.36 356.36l-.24-.55z" fill="url(#linear-gradient-54)" opacity=".9" />
					<path d="M3.16 347.11z" fill="url(#linear-gradient-55)" opacity=".9" />
					<path
						d="M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z"
						fill="url(#linear-gradient-56)"
						opacity=".9"
					/>
					<path
						d="M3.44 343.18v.06a.64.64 0 000-.07z"
						fill="url(#linear-gradient-57)"
						opacity=".9"
					/>
					<path fill="url(#linear-gradient-58)" opacity=".9" d="M10.57 363.88z" />
					<path
						d="M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z"
						fill="url(#linear-gradient-59)"
						opacity=".9"
					/>
					<path
						d="M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z"
						fill="url(#linear-gradient-60)"
					/>
					<path
						d="M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z"
						fill="url(#linear-gradient-61)"
						opacity=".9"
					/>
					<path d="M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z" fill="url(#linear-gradient-62)" />
					<path d="M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z" fill="url(#linear-gradient-63)" />
					<path
						d="M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z"
						fill="url(#linear-gradient-64)"
						opacity=".9"
					/>
					<path d="M230.88 375.15h14v-3.25z" fill="url(#linear-gradient-65)" />
					<path d="M230.88 375.15h14v-3.25z" fill="url(#linear-gradient-66)" />
					<path d="M230.88 375.15h14v-3.25z" fill="url(#linear-gradient-67)" opacity=".9" />
					<path
						d="M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z"
						fill="url(#linear-gradient-68)"
					/>
					<path
						d="M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z"
						fill="url(#linear-gradient-69)"
					/>
					<path
						d="M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z"
						fill="url(#linear-gradient-70)"
						opacity=".9"
					/>
					<path
						d="M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z"
						fill="url(#linear-gradient-71)"
					/>
					<path
						d="M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z"
						fill="url(#linear-gradient-72)"
					/>
					<path
						d="M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z"
						fill="url(#linear-gradient-73)"
					/>
					<path
						d="M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z"
						fill="url(#linear-gradient-74)"
						opacity=".9"
					/>
					<path
						d="M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z"
						fill="url(#linear-gradient-75)"
					/>
					<path
						d="M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z"
						fill="url(#linear-gradient-76)"
					/>
					<path
						d="M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z"
						fill="url(#linear-gradient-77)"
					/>
					<path
						d="M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z"
						fill="url(#linear-gradient-78)"
						opacity=".9"
					/>
					<path
						d="M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z"
						fill="url(#linear-gradient-79)"
					/>
					<path
						d="M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z"
						fill="url(#linear-gradient-80)"
					/>
					<path
						d="M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z"
						fill="url(#linear-gradient-81)"
					/>
					<path
						d="M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z"
						fill="url(#linear-gradient-82)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
					/>
					<path
						d="M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
						fill="url(#linear-gradient-83)"
					/>
					<path
						d="M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
						fill="url(#linear-gradient-84)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
					/>
					<path
						d="M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
						fill="url(#linear-gradient-85)"
					/>
					<path
						d="M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
						fill="url(#linear-gradient-86)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
					/>
					<path
						d="M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
						fill="url(#linear-gradient-87)"
						opacity=".9"
					/>
					<path
						d="M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z"
						fill="url(#linear-gradient-88)"
					/>
					<path
						d="M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z"
						fill="url(#linear-gradient-89)"
					/>
					<path
						d="M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z"
						fill="url(#linear-gradient-90)"
						opacity=".9"
					/>
					<path
						d="M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z"
						fill="url(#linear-gradient-91)"
					/>
					<path
						d="M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z"
						fill="url(#linear-gradient-92)"
					/>
					<path
						d="M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z"
						fill="url(#linear-gradient-93)"
					/>
					<path
						d="M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z"
						fill="url(#linear-gradient-94)"
						opacity=".9"
					/>
					<path
						d="M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z"
						fill="url(#linear-gradient-95)"
					/>
					<path
						d="M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z"
						fill="url(#linear-gradient-96)"
						opacity=".9"
					/>
					<path
						d="M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z"
						fill="url(#linear-gradient-97)"
						opacity=".9"
					/>
					<path
						d="M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z"
						fill="url(#linear-gradient-98)"
					/>
					<path
						d="M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z"
						fill="url(#linear-gradient-99)"
						opacity=".9"
					/>
					<path
						d="M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z"
						fill="url(#linear-gradient-100)"
						opacity=".9"
					/>
					<path
						d="M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z"
						fill="url(#linear-gradient-101)"
					/>
					<path
						d="M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z"
						fill="url(#linear-gradient-102)"
					/>
					<path
						d="M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z"
						fill="url(#linear-gradient-103)"
						opacity=".9"
					/>
					<path
						d="M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z"
						fill="url(#linear-gradient-104)"
						opacity=".9"
					/>
					<path
						d="M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z"
						fill="url(#linear-gradient-105)"
					/>
					<path
						d="M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z"
						fill="url(#linear-gradient-106)"
					/>
					<path
						d="M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z"
						fill="url(#linear-gradient-107)"
					/>
					<path
						d="M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z"
						fill="url(#linear-gradient-108)"
						opacity=".9"
					/>
					<path
						d="M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z"
						fill="url(#linear-gradient-109)"
						opacity=".9"
					/>
					<path
						d="M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z"
						fill="url(#linear-gradient-110)"
					/>
					<path
						d="M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z"
						fill="url(#linear-gradient-111)"
					/>
					<path
						d="M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z"
						fill="url(#linear-gradient-112)"
					/>
					<path
						d="M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z"
						fill="url(#linear-gradient-113)"
						opacity=".9"
					/>
					<path
						d="M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z"
						fill="url(#linear-gradient-114)"
						opacity=".9"
					/>
					<path
						d="M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z"
						fill="url(#linear-gradient-115)"
					/>
					<path
						d="M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z"
						fill="url(#linear-gradient-116)"
					/>
					<path
						d="M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z"
						fill="url(#linear-gradient-117)"
					/>
					<path
						d="M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z"
						fill="url(#linear-gradient-118)"
						opacity=".9"
					/>
					<path
						d="M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z"
						fill="url(#linear-gradient-119)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
					/>
					<path
						d="M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
						fill="url(#linear-gradient-120)"
					/>
					<path
						d="M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
						fill="url(#linear-gradient-121)"
						opacity=".9"
					/>
					<path
						d="M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
						fill="url(#linear-gradient-122)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
					/>
					<path
						d="M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
						fill="url(#linear-gradient-123)"
					/>
					<path
						d="M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
						fill="url(#linear-gradient-124)"
						opacity=".9"
					/>
					<path
						d="M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
						fill="url(#linear-gradient-125)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
					/>
					<path
						d="M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
						fill="url(#linear-gradient-126)"
						opacity=".9"
					/>
					<path
						d="M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
						fill="url(#linear-gradient-127)"
						opacity=".9"
					/>
					<path
						d="M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z"
						fill="url(#linear-gradient-128)"
					/>
					<path
						d="M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z"
						fill="url(#linear-gradient-129)"
					/>
					<path
						d="M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z"
						fill="url(#linear-gradient-130)"
						opacity=".9"
					/>
					<path
						d="M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z"
						fill="url(#linear-gradient-131)"
						opacity=".9"
					/>
					<path
						d="M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z"
						fill="url(#linear-gradient-132)"
					/>
					<path
						d="M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z"
						fill="url(#linear-gradient-133)"
					/>
					<path
						d="M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z"
						fill="url(#linear-gradient-134)"
					/>
					<path
						d="M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z"
						fill="url(#linear-gradient-135)"
						opacity=".9"
					/>
					<path
						d="M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z"
						fill="url(#linear-gradient-136)"
						opacity=".9"
					/>
					<path
						d="M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z"
						fill="url(#linear-gradient-137)"
					/>
					<path
						d="M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z"
						fill="url(#linear-gradient-138)"
						opacity=".9"
					/>
					<path
						d="M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z"
						fill="url(#linear-gradient-139)"
						opacity=".9"
					/>
					<path
						d="M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z"
						fill="url(#linear-gradient-140)"
						opacity=".9"
					/>
					<path
						d="M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z"
						fill="url(#linear-gradient-141)"
					/>
					<path
						d="M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z"
						fill="url(#linear-gradient-142)"
					/>
					<path
						d="M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z"
						fill="url(#linear-gradient-143)"
						opacity=".9"
					/>
					<path
						d="M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z"
						fill="url(#linear-gradient-144)"
						opacity=".9"
					/>
					<path
						d="M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z"
						fill="url(#linear-gradient-145)"
						opacity=".9"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-146)"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-147)"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-148)"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-149)"
						opacity=".9"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-150)"
						opacity=".9"
					/>
					<path
						d="M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z"
						fill="url(#linear-gradient-151)"
						opacity=".9"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-152)"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-153)"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-154)"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-155)"
						opacity=".9"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-156)"
						opacity=".9"
					/>
					<path
						d="M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z"
						fill="url(#linear-gradient-157)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
					/>
					<path
						d="M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
						fill="url(#linear-gradient-158)"
					/>
					<path
						d="M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
						fill="url(#linear-gradient-159)"
						opacity=".9"
					/>
					<path
						d="M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
						fill="url(#linear-gradient-160)"
						opacity=".9"
					/>
					<path
						d="M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
						fill="url(#linear-gradient-161)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
					/>
					<path
						d="M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
						fill="url(#linear-gradient-162)"
					/>
					<path
						d="M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
						fill="url(#linear-gradient-163)"
						opacity=".9"
					/>
					<path
						d="M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
						fill="url(#linear-gradient-164)"
						opacity=".9"
					/>
					<path
						d="M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
						fill="url(#linear-gradient-165)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
					/>
					<path
						d="M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
						fill="url(#linear-gradient-166)"
						opacity=".9"
					/>
					<path
						d="M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
						fill="url(#linear-gradient-167)"
						opacity=".9"
					/>
					<path
						d="M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
						fill="url(#linear-gradient-168)"
						opacity=".9"
					/>
					<path
						d="M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z"
						fill="url(#linear-gradient-169)"
					/>
					<path
						d="M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z"
						fill="url(#linear-gradient-170)"
					/>
					<path
						d="M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z"
						fill="url(#linear-gradient-171)"
						opacity=".9"
					/>
					<path
						d="M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z"
						fill="url(#linear-gradient-172)"
						opacity=".9"
					/>
					<path
						d="M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z"
						fill="url(#linear-gradient-173)"
						opacity=".9"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-174)"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-175)"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-176)"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-177)"
						opacity=".9"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-178)"
						opacity=".9"
					/>
					<path
						d="M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z"
						fill="url(#linear-gradient-179)"
						opacity=".9"
					/>
					<path
						d="M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z"
						fill="url(#linear-gradient-180)"
					/>
					<path
						d="M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z"
						fill="url(#linear-gradient-181)"
						opacity=".9"
					/>
					<path
						d="M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z"
						fill="url(#linear-gradient-182)"
						opacity=".9"
					/>
					<path
						d="M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z"
						fill="url(#linear-gradient-183)"
						opacity=".9"
					/>
					<path
						d="M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z"
						fill="url(#linear-gradient-184)"
						opacity=".9"
					/>
					<path d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z" fill="url(#linear-gradient-185)" />
					<path d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z" fill="url(#linear-gradient-186)" />
					<path
						d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z"
						fill="url(#linear-gradient-187)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z"
						fill="url(#linear-gradient-188)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z"
						fill="url(#linear-gradient-189)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z"
						fill="url(#linear-gradient-190)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-191)"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-192)"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-193)"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-194)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-195)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-196)"
						opacity=".9"
					/>
					<path
						d="M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z"
						fill="url(#linear-gradient-197)"
						opacity=".9"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-50"
						d="M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
					/>
					<path
						d="M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
						fill="url(#linear-gradient-198)"
						opacity=".9"
					/>
					<path
						d="M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
						fill="url(#linear-gradient-199)"
						opacity=".9"
					/>
					<path
						d="M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
						fill="url(#linear-gradient-200)"
						opacity=".9"
					/>
					<path
						d="M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
						fill="url(#linear-gradient-201)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-202)"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-203)"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-204)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-205)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-206)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z"
						fill="url(#linear-gradient-207)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-208)"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-209)"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-210)"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-211)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-212)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-213)"
						opacity=".9"
					/>
					<path
						d="M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z"
						fill="url(#linear-gradient-214)"
						opacity=".9"
					/>
					<path d="M68.73 400.78z" fill="url(#radial-gradient)" />
					<path d="M69.21 410.07z" fill="url(#radial-gradient-2)" />
					<path
						d="M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z"
						fill="url(#radial-gradient-3)"
					/>
					<path d="M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z" fill="url(#radial-gradient-4)" />
					<path d="M69.36 405.62v2c.03-.68.03-1.34 0-2z" fill="url(#radial-gradient-5)" />
					<path
						d="M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z"
						fill="url(#radial-gradient-6)"
					/>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766  */}
					<path className="cls-228" d="M56.49 388.64z" />
					<path d="M50.53 386.83l1.71.49-1.71-.49z" fill="url(#radial-gradient-8)" />
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-230"
						d="M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
					/>
					<path d="M60.16 390.12z" fill="url(#radial-gradient-10)" />
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<path className="cls-230" d="M58.25 389.29l-1.4-.53z" />
					<path
						d="M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z"
						fill="url(#radial-gradient-12)"
					/>
					<path
						d="M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z"
						fill="url(#radial-gradient-13)"
					/>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766  */}
					<path className="cls-228" d="M54.24 387.91l-1.46-.44z" />
					<path d="M63.42 392.06z" fill="url(#radial-gradient-15)" />
					<path
						d="M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z"
						fill="url(#linear-gradient-215)"
					/>
					<path
						d="M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
						fill="url(#linear-gradient-216)"
					/>
					<path
						d="M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
						fill="url(#linear-gradient-217)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-230"
						d="M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
					/>
					<path
						fill="url(#linear-gradient-218)"
						d="M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
					/>
					<path
						d="M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z"
						fill="url(#linear-gradient-219)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-240"
						d="M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
					/>
					<path
						d="M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z"
						fill="url(#linear-gradient-220)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-242"
						d="M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
					/>
					<path
						d="M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z"
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						style={{ mixBlendMode: 'multiply' }}
						fill="url(#linear-gradient-221)"
						opacity=".1"
					/>
					<ellipse
						cx="190.18"
						cy="308.96"
						rx="48.27"
						ry="5.8"
						fill="url(#linear-gradient-222)"
						opacity=".1"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
					/>
					<path
						d="M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z"
						fill="url(#linear-gradient-223)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-247"
						d="M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-247"
						d="M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-4"
						d="M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
					/>
					<path
						d="M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z"
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						style={{ mixBlendMode: 'multiply' }}
						fill="url(#linear-gradient-224)"
						opacity=".1"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-249"
						d="M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-242"
						d="M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-250"
						d="M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
					/>
					<path
						d="M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z"
						fill="#2684ff"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
					/>
					<path
						d="M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23"
						fill="#543e36"
					/>
					<path
						d="M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55"
						fill="#091e42"
					/>
					<path
						d="M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8"
						fill="#253858"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-250"
						d="M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-250"
						d="M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-4"
						d="M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-250"
						d="M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
					/>
					<path
						d="M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z"
						fill="url(#linear-gradient-225)"
					/>
					<path
						fill="url(#linear-gradient-226)"
						d="M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-242"
						d="M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
					/>
					<path
						fill="url(#linear-gradient-227)"
						d="M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
					/>
					<path
						fill="url(#linear-gradient-228)"
						d="M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
					/>
					<path d="M245.55 0a5 5 0 015 5v201.67h-5V0z" fill="#fafbfc" />
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<path className="cls-242" d="M245.54 0v206.67h-5V5a5 5 0 015-5z" />
					<path
						d="M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z"
						fill="url(#linear-gradient-229)"
					/>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766  */}
					<g className="cls-261">
						<path
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="cls-262"
							d="M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
						/>
					</g>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<g className="cls-261">
						<path
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="cls-262"
							d="M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
						/>
					</g>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<g className="cls-261">
						<path
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="cls-262"
							d="M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
						/>
					</g>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<g className="cls-261">
						<path
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="cls-262"
							d="M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
						/>
					</g>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<g className="cls-261">
						<path
							// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
							className="cls-262"
							d="M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
						/>
					</g>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
					/>
					<path
						d="M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z"
						fill="url(#linear-gradient-230)"
					/>
					<path
						d="M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z"
						fill="url(#linear-gradient-231)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-245"
						d="M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
					/>
					<path
						d="M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z"
						fill="url(#linear-gradient-232)"
					/>
					<path
						d="M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z"
						transform="rotate(91.28 158.41 193.83)"
						fill="url(#New_Gradient_Swatch_13)"
					/>
					<path
						d="M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z"
						transform="rotate(91.28 167.981 194.045)"
						fill="url(#New_Gradient_Swatch_13-2)"
					/>
					<path
						transform="rotate(91.28 176.118 194.226)"
						fill="url(#New_Gradient_Swatch_13-3)"
						d="M175.15 190.6h1.92v7.27h-1.92z"
					/>
					<rect
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-247"
						x="178.59"
						y="193.96"
						width="3.06"
						height=".74"
						rx=".3"
						transform="rotate(91.28 180.12 194.325)"
					/>
					<rect
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-247"
						x="150.26"
						y="193.12"
						width="4.96"
						height="1.2"
						rx=".49"
						transform="rotate(91.28 152.736 193.71)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						d="M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
					/>
					<rect
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						x="166.04"
						y="191.29"
						width="1.47"
						height="2.35"
						rx=".73"
						transform="rotate(180 166.77 192.47)"
					/>
					<rect
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-263"
						x="169.9"
						y="191.29"
						width="1.47"
						height="2.35"
						rx=".73"
						transform="rotate(-180 170.63 192.47)"
					/>
					<path
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className="cls-249"
						d="M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
					/>
					<path
						d="M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z"
						fill="url(#linear-gradient-233)"
					/>
					<path fill="url(#linear-gradient-234)" d="M301.4 385.02l4.39 1.02" />
					<path
						d="M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z"
						fill="url(#linear-gradient-235)"
					/>
				</g>
			</g>
		</g>
	</svg>
);
